

<a [attr.href]="link" class="link" >  
        <svg width="20px" height="24px" viewBox="0 0 20 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-170.000000, -1185.000000)">
                    <g transform="translate(135.000000, 1152.000000)">
                        <g transform="translate(30.000000, 30.000000)">
                            <rect x="0" y="0" width="30" height="30"></rect>
                            <path stroke="#99A2AA" d="M6,26 L24,26"  stroke-width="1.5" stroke-linecap="round"></path>
                            <path stroke="#99A2AA" d="M19.6338835,11.8661165 L19.6338835,20.3838835 C19.6338835,20.798097 19.298097,21.1338835 18.8838835,21.1338835 L10.3661165,21.1338835"  stroke-width="1.5" stroke-linecap="round" transform="translate(15.000000, 16.500000) rotate(45.000000) translate(-15.000000, -16.500000) "></path>
                            <path stroke="#99A2AA" d="M15,4.5 L15,22.3345682"  stroke-width="1.5" stroke-linecap="round"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        <!--<div class="wrapper" >
            <span class="buttonLabel">{{ buttonLabel }}</span>
        </div>-->
        <span class='label'>
            {{ buttonLabel }}
        </span>
        
</a>